"use client";

import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";

import { ProjectCard } from "./ProjectCard";
import type { ProjectCardProps } from "./ProjectCard";

export type SortableProjectCardProps = Omit<
  ProjectCardProps,
  "dragHandle" | "cardRef" | "style" | "className"
> & {
  id: string;
};

/**
 * Project card with dnd-kit sortable transform.
 * Drag target is only the top header row (icon + status badge).
 */
export function SortableProjectCard({
  id,
  ...cardProps
}: SortableProjectCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <ProjectCard
      {...cardProps}
      projectId={cardProps.projectId ?? id}
      cardRef={setNodeRef}
      style={style}
      dragHandle={{
        attributes,
        listeners,
        isDragging,
      }}
    />
  );
}
